import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const LastName = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;
    if (value.trim().length < 1) return 'Please enter your last name';
    if (!regex.test(value.trim())) return 'Please enter a valid name';
    return true;
  };

  return (
    <ValidatingInput
      autoComplete="family-name"
      label="Last name"
      name="lastName"
      placeholder="Last name"
      maxLength={32}
      validate={validate}
      {...props}
    />
  );
};
